import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["blockType", "content", "title"];

  insertVariable(event) {
    const token = event.currentTarget.dataset.token;
    if (!token || !this.hasContentTarget || !this.contentTarget.editor) return;

    this.contentTarget.focus();
    this.contentTarget.editor.insertString(token);
  }

  applySuggestion(event) {
    const button = event.currentTarget;
    const title = button.dataset.title || "";
    const blockType = button.dataset.blockType || "full_text";
    const template = button.dataset.template || "";

    if (this.hasTitleTarget) {
      this.titleTarget.value = title;
    }

    this.blockTypeTargets.forEach((input) => {
      input.checked = input.value === blockType;
    });

    if (this.hasContentTarget && this.contentTarget.editor) {
      this.contentTarget.editor.loadHTML(this.htmlFromText(template));
      this.contentTarget.focus();
    }
  }

  close() {
    this.element.outerHTML = '<div id="new-text-block-form"></div>';
  }

  htmlFromText(text) {
    const escaped = this.escapeHtml(text || "");
    const paragraphs = escaped
      .split(/\n{2,}/)
      .map((paragraph) => paragraph.replace(/\n/g, "<br>"))
      .filter((paragraph) => paragraph.trim().length > 0);

    return paragraphs.length ? paragraphs.map((paragraph) => `<p>${paragraph}</p>`).join("") : "";
  }

  escapeHtml(value) {
    const wrapper = document.createElement("div");
    wrapper.textContent = value;
    return wrapper.innerHTML;
  }
}
